import React, { useState } from 'react';
import { useGameStore } from '../../store/game-store.js';
import './GuessHistory.css';

export default function GuessHistory() {
  const [open, setOpen] = useState(false);
  const guessHistory = useGameStore(s => s.guessHistory);

  if (guessHistory.length === 0) return null;

  return (
    <div className={`guess-history ${open ? 'guess-history--open' : ''}`}>
      <button className="guess-history__toggle" onClick={() => setOpen(!open)}>
        <span className="guess-history__count">{guessHistory.length} guesses</span>
        <span className="guess-history__chevron">{open ? '\u25BC' : '\u25B2'}</span>
      </button>

      {open && (
        <ul className="guess-history__list">
          {[...guessHistory].reverse().map((g, i) => (
            <li
              key={i}
              className={`guess-history__item ${g.success ? 'guess-history__item--success' : 'guess-history__item--fail'}`}
            >
              <span className="guess-history__dot" />
              <span className="guess-history__label">
                {g.label || g.input || '?'}
              </span>
              {g.type && (
                <span className="guess-history__type">
                  {g.type === 'actor' ? 'Star' : g.type === 'movie' ? 'Film' : 'TV'}
                </span>
              )}
              {!g.success && g.reason && (
                <span className="guess-history__reason">
                  {g.reason === 'no-match' ? 'Not in pool' :
                   g.reason === 'no-connection' ? 'No connection' :
                   g.reason === 'already-found' ? 'Already found' :
                   g.reason}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
